import React, {forwardRef, useEffect, useState} from "react";
import {getCtrlOrAlt, getImagePathWithTheme, imgPathPerfix} from "../../utils";
import {HOME_LEFT_MENU_WIDTH} from "@/Const";
import {useAtom} from "jotai";
import {atomHomePaddingLeft, atomIsFullscreen} from "@/views/Home/HomeIndex";
import {Popover, Tooltip} from "antd";
import {t} from "i18next";
import {createHashHistory} from "history";
import {ipcOn} from "@/common/ipc";
import {isMac} from "@/Utility";
import {debugLog} from "@/LogUtils";

const HomeNavigator = forwardRef((props:{margin?:any,onBeforeBack?:any,onBeforeForward?:any}, ref)=> {

    const hashHistory = createHashHistory();
    const [homePaddingLeft, setHomePaddingLeft] = useAtom(atomHomePaddingLeft);
    const [isFullScreen,setIsFullScreen] = useAtom(atomIsFullscreen);

    function onKeyDown(event){
        // debugLog('keydown',event);

        if (isMac()){
            if (event.metaKey && event.key == '['){
                history.back();
            }else if (event.metaKey && event.key == ']'){
                history.forward();
            }
        }else{
            if (event.altKey && event.key.toLowerCase() == 'arrowleft'){
                history.back();
            }else if (event.altKey && event.key.toLowerCase() == 'arrowright'){
                history.forward();
            }
        }
    }

    useEffect(()=>{
        ipcOn('full-screen',(event,args)=>{
            setIsFullScreen(args.isFullScreen);
        })

        document.body.addEventListener('keydown',onKeyDown);

        return ()=>{
            document.body.removeEventListener('keydown',onKeyDown);
        }
    })

    return (
        <div className={'flex-row-vertical-center'} style={{margin: props.margin || '0px'}}>
            {
                //带logo的 marginLeft: isFullScreen?'120px':'80px'
                homePaddingLeft == 0 &&
                <Tooltip overlayClassName='font-size-12' title={
                    <div>{t("Sidebar")}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + /")}</span></div>}
                         arrow={true}>
                <img id={'home-navigator-left-slider'} className={'cursor-pointer ml-16 mr-10 hovered-gray-radius'} style={{width: '32px', height: '32px', marginLeft: (isFullScreen || !isMac())?'0px':'80px'}}
                     src={getImagePathWithTheme("home_left_slider.svg")} onClick={() => {
                    setHomePaddingLeft(HOME_LEFT_MENU_WIDTH)
                }}/>
                </Tooltip>
            }

            <Tooltip overlayClassName='font-size-12' title={
                <div>{t("Go back")}<span className={'tooltip-shortcut-key'}>{isMac() ? "Cmd + [" : ("Alt + ←")}</span>
                </div>} arrow={true}>
                <img className={'cursor-pointer img-32 hovered-gray-radius'} onClick={() => {
                    // history.back();
                    if (props.onBeforeBack) {
                        const isHandle = (props.onBeforeBack());
                        if (!isHandle) {
                            hashHistory.back();
                        }
                    }else {
                        hashHistory.back();
                    }
                }}
                     src={getImagePathWithTheme("nagivator_back.svg")}/>
            </Tooltip>

            <Tooltip overlayClassName='font-size-12' title={
                <div>{t("Go forward")}<span
                    className={'tooltip-shortcut-key'}>{isMac() ? "Cmd + ]" : ("Alt + →")}</span></div>} arrow={true}>
                <img className={'cursor-pointer ml-6 img-32 hovered-gray-radius'} onClick={() => {
                    // history.forward();
                    if (props.onBeforeForward) {
                        const isHandle = (props.onBeforeForward());
                        if (!isHandle) {
                            hashHistory.forward();
                        }
                    }else {
                        hashHistory.forward();
                    }
                }}
                     src={getImagePathWithTheme("nagivator_forward.svg")}/>
            </Tooltip>
        </div>
    )
})

export default HomeNavigator;